import { render, staticRenderFns } from "./FreeText.vue?vue&type=template&id=56508c66&scoped=true&"
import script from "./FreeText.vue?vue&type=script&lang=js&"
export * from "./FreeText.vue?vue&type=script&lang=js&"
import style0 from "./FreeText.vue?vue&type=style&index=0&id=56508c66&prod&scoped=true&lang=css&"
import style1 from "./FreeText.vue?vue&type=style&index=1&id=56508c66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56508c66",
  null
  
)

export default component.exports